import React from "react"
import * as styles from "./Styles/Title.module.scss"

const Title: React.FC<{ name: string; lastUpdatedAt: string }> = ({
  name,
  lastUpdatedAt,
}) => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{name}の避難所の混雑状況</h1>
      {lastUpdatedAt && (
        <div className={styles.updatedAt}>
          更新：
          {lastUpdatedAt}
        </div>
      )}
    </div>
  )
}
export default Title
